import * as React from "react"
import { SVGProps } from "react"

const IconLoading = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        {...props}
    >
        <circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" strokeWidth="3" strokeOpacity="0.2" />
        <circle cx="10" cy="10" r="8.5" fill="none" stroke="currentColor" strokeWidth="3"
            strokeDasharray="13.3525 40.0575" />
    </svg>
)

export default IconLoading
